<template>
  <div class="supplier-haulier-main">
    <div :style="{ width: showPM ? '50%' : '100%', paddingRight: '5px', position: 'relative' }">
      <Input placeholder="Haulier Code" :inputValue.sync="data.haulierCode" :isDisabled="viewMode" />
      <Input placeholder="CMR Form" :isRequired="true" :inputValue.sync="data.cmrForm" :isDisabled="viewMode" ref="CMRForm" />
      <Dropdown placeholder="Mode" :isRequired="true" :items="data.modeItems" :selectedObject.sync="data.selectedMode" :isDisabled="viewMode" ref="DepotTrMode" />
      <InputQuery placeholder="DGC Bill To" :items="data.billToItems" :selectedObject.sync="data.selectedBillTo" itemKey="Customer Code" descKey="Customer Name" :isDisabled="viewMode" />
      <button style="right: 5px; position: absolute" @click="showPM ^= true">{{ showPM ? 'Close' : viewMode ? 'View PM' : 'Add/View PM' }}</button>
      <div class="flex-area" style="margin-top: 45px">
        <Input placeholder="Company Registration No" :inputValue.sync="data.coRegNo" :isDisabled="viewMode" />
        <Input style="margin-left: 5px" placeholder="PKNet ID" :inputValue.sync="data.pkNetID" :isDisabled="viewMode" />
      </div>
      <div class="flex-area">
        Date Verified : <DateTimePicker :value.sync="dateVerified" :isDisabled="viewMode" />
      </div>
      <Input placeholder="License No" :inputValue.sync="data.licenseNo" :isDisabled="viewMode" />
      <Input placeholder="RMCD Approval No" :inputValue.sync="data.rmcdApprovalNo" :isDisabled="viewMode" />
    </div>
    <div class="right-container" :style="{ width: showPM ? '50%' : '0px', height: showPM ? 'auto' : '0px' }">
      <Tabulator class="pm-tabulator" :style="{ width: viewMode ? '100%' : 'calc(100% - 105px)' }" :tableData="data.vehicleItems" :hideColumns="hiddenColumns" :selectedRow.sync="selectedPM" />
      <div class="add-pm-area" v-if="!viewMode">
        <Input placeholder="PM No" :inputValue.sync="pmNo" :isRequired="true" :errorMessage.sync="pmError" />
        <Dropdown placeholder="Mvt" :items="data.mvtItems" :selectedObject.sync="selectedMvt" />
        <button style="margin-bottom: 3px; width: 100%" @click="addPM">+ Add PM</button>
        <button style="width: 100%" @click="delPM">- Del PM</button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Input from '@/components/Input.vue';
import DateTimePicker from '@/components/DateTimePicker.vue';
import InputQuery from '@/components/InputQuery.vue';
import Dropdown from '@/components/Dropdown.vue';
import Tabulator from '@/components/Tabulator.vue';

export default {
  components: {
    Input, DateTimePicker, InputQuery, Dropdown, Tabulator
  },
  props: {
    data: { type: Object, default: function() { return {} } },
    showPM: { type: Boolean, default: false },
    hiddenColumns: { type: Array, default: function() { return [ 'Spp_Code', 'VehicleCode', 'VehicleCategory', 'vehicleaction' ] } },
    pmNo: { type: String, default: '' },
    pmError: { type: String, default: '' },
    selectedMvt: { type: Object, default: null },
    selectedPM: { type: Array, default: function() { return [] } },
    viewMode: { type: Boolean, default: false },
  },
  methods: {
    addPM: function() {
      if (this.pmNo) {
        this.$bus.$emit('pmAdded', { Lorry_No: this.pmNo, Type: this.selectedMvt ? this.selectedMvt['Mvt'] : '' });
        this.pmNo = '';
        this.selectedMvt = null;
      } else {
        this.pmError = 'PM No is required';
      }
    },
    delPM: async function() {
      if (this.selectedPM.length == 0) {
        this.$showAlert('error', 'No PM Selected', 'Please select PM on the list to delete');
      } else {
        var delPM = await this.$showAlert(
              'warning', 
              'PM Delete', 
              `Are you sure you want to delete ${this.selectedPM.length} PM(s)?`, 
              [{"text" : "Delete"}, {"text" : "Cancel"}]
              );
        if (delPM === "Delete") {
          this.$bus.$emit('pmDeleted', this.selectedPM);
        }
      }
    }
  },
  mounted() {
    this.$bus.$on('supplierHaulierFocusElement', (element) => {
      this.$refs[element].setFocus();
    });
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.supplier-haulier-main {
  display: flex;
}

.flex-area {
  display: flex;
  align-items: center;
}

.right-container {
  overflow: hidden;
  display: flex;
  padding-top: 10px;

  > .pm-tabulator {
    width: calc(100% - 105px);
    height: fit-content;
  }

  > .add-pm-area {
    width: 100px;
    margin-left: 5px;
  }
}
</style>